export enum ModalNames {
  SHARED_PERMISSION_MODAL = 'SHARED_PERMISSION_MODAL',
}
